import React, {useState} from 'react';
import Modal from "react-modal";
import {Button, Col, FloatingLabel, Form, Row} from "react-bootstrap";
import {useForm} from 'react-hook-form';

const StudentsItem = ({item, idx, deleteStudent, editStudent,  customStyles}) => {
    const {register, handleSubmit, formState: {errors}} = useForm();
    const [modalIsOpen, setIsOpen] = useState(false)


    const handleUpdate = (data) => {
        editStudent(item.id, data)
        setIsOpen(false)
    }

    return (
        <tr>
            <td>{idx + 1}</td>
            <td>{item.name}</td>
            <td>{item.phone}</td>
            <td>{item.contract}</td>
            <td>{item.pay}</td>
            <td>{item.laptop}</td>
            <td>{item.group}</td>
            <td>{item.comment}</td>
            <td>
                <div className='student-status text-center'>
                    {item.status}
                </div>
            </td>
            <td className='text-center'>
                <i onClick={() => setIsOpen(true)} className='bx bx-edit-alt text-info me-4'/>
                <i onClick={() => deleteStudent(item.id)} className='bx bx-trash text-danger'/>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={()=> setIsOpen(false)}
                    style={customStyles}
                >
                    <div className='position-relative'>
                        <Form onSubmit={handleSubmit(handleUpdate)}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control defaultValue={item.name}
                                                  id='formGridName' {...register("name", {required: true})}
                                                  type="text"/>
                                    {errors.name && <span className='text-danger'>Add name</span>}
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridNumber">
                                    <Form.Label>Phone number</Form.Label>
                                    <Form.Control defaultValue={item.phone}
                                                  id='formGridNumber' {...register("phone", {required: true})}
                                                  type="text"/>
                                    {errors.phone && <span className='text-danger'>Add phone</span>}
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridContract">
                                    <Form.Label>Summ of contract</Form.Label>
                                    <Form.Control defaultValue={item.contract}
                                                  id='formGridContract' {...register("contract", {required: true})}
                                                  type="number"/>
                                    {errors.contract && <span className='text-danger'>Add contract</span>}
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridPayed">
                                    <Form.Label>Payed</Form.Label>
                                    <Form.Control defaultValue={item.pay}
                                                  id="formGridPayed" {...register("pay", {required: true})}
                                                  type="number"/>
                                    {errors.pay && <span className='text-danger'>Add pay</span>}
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" controlId="formGridLaptop">
                                <Form.Label>Laptop</Form.Label>
                                <Form.Control defaultValue={item.laptop}
                                              id="formGridLaptop" {...register("laptop", {required: true})}
                                              type="text"/>
                                {errors.laptop && <span className='text-danger'>Add laptop</span>}
                            </Form.Group>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridGroup">
                                    <Form.Label>Group</Form.Label>
                                    <Form.Select {...register("group", {required: true})} defaultValue={item.group}>
                                        <option selected={true} disabled={true}>Choose group</option>
                                        <option>Morning</option>
                                        <option>Evening</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select id='formGridStatus' {...register("status", {required: true})}
                                                 defaultValue={item.status}>
                                        <option selected={true} disabled={true}>Choose status</option>
                                        <option>Active</option>
                                        <option>Not active</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridGender">
                                    <Form.Label>Gender</Form.Label>
                                    <Form.Select id="formGridGender" {...register("gender", {required: true})}
                                                 defaultValue={item.gender}>
                                        <option selected={true} disabled={true}>Choose gender</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <FloatingLabel controlId="floatingTextarea2" label="Comments">
                                <Form.Control
                                    defaultValue={item.comment}
                                    id='floatingTextarea2'
                                    {...register("comment", {required: true})}
                                    as="textarea"
                                    style={{height: '100px'}}
                                />
                                {errors.comment && <span className='text-danger'>Add comment</span>}
                            </FloatingLabel>
                            <Button className='student-modal-btn' variant="primary" type="submit">
                                Update
                            </Button>
                        </Form>
                        <div onClick={()=> setIsOpen(false)} className='close-modal position-absolute'>❌</div>
                    </div>
                </Modal>
            </td>
        </tr>
    );
};

export default StudentsItem;